$(document).ready(function(){
    $('.brand_section').slick({
  dots: false,
      arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
        arrows: false,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows: false
      }
    }
  ]
});
  })

$(document).on('click', '.header__inline-menu a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});
$(document).on('click', '.wholesale_nav_section_wrap .nav_item a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});
$(document).ready(function(){
  $('.wholesale_nav_section_wrap .nav_item a').click(function(){
    $('.wholesale_nav_section_wrap .nav_item a').removeClass('active');
    $(this).addClass('active');  
  });
});
$(document).ready(function(){
$('.edit_btn_address').click(function(){
  $('.address_text').toggle();
});
  $('.cancel_button').click(function(){
    $('.address_text').show();
  })
  
})
var clicked = 0;

  $(".toggle-password").click(function (e) {
     e.preventDefault();

    $(this).toggleClass("toggle-password");
      if (clicked == 0) {
        $(this).html('<span class="material-icons">visibility_off</span >');
         clicked = 1;
      } else {
         $(this).html('<span class="material-icons">visibility</span >');
          clicked = 0;
       }

    var input = $($(this).attr("toggle"));
    if (input.attr("type") == "password") {
       input.attr("type", "text");
    } else {
       input.attr("type", "password");
    }
});
$(function(){
    $(".example").mapael({
        map : {
          name : "world_countries"
        },
      areas: {
        "AU": {
                "value": 22851324,
                "href":"/products/maynicoffee",
                "tooltip": {
                  "content": "<div class='map_image_wrap'> <div class='map_back_with_video_text'> <div class='map_video'> <iframe width='560' height='315' src='https://www.youtube.com/embed/9TPb4xGZkpg' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen=''></iframe></div> <div class='map-video_with_text'><div class='map_video_text'> <div class='video_title'> <h3>Mayni</h3> </div> <div class='video_content'><p>The Mayni harness their natural landscape while protecting the natural eco-system, foliage and wildlife, expertly handpicking their beautiful crop to minimise any damage. </p></div><div class='map_btn_wrap'> <a class='btn' href='#'> Shop Mayni coffee <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'></path> </svg> </a> </div> </div> </div> </div> </div>"
                 }
            },
        "PE": {
                "value": 47887653,
                "href":"/products/maynicoffee",
                "tooltip": {
                    "content": "<div class='map_image_wrap'> <div class='map_back_with_video_text'> <div class='map_video'> <iframe width='560' height='315' src='https://www.youtube.com/embed/9TPb4xGZkpg' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen=''></iframe></div> <div class='map-video_with_text'><div class='map_video_text'> <div class='video_title'> <h3>Mayni</h3> </div> <div class='video_content'><p>The Mayni harness their natural landscape while protecting the natural eco-system, foliage and wildlife, expertly handpicking their beautiful crop to minimise any damage. </p></div><div class='map_btn_wrap'> <a class='btn' href='#'> Shop Mayni coffee <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'></path> </svg> </a> </div> </div> </div> </div> </div>"
                }
            },
        "RW": {
                "value": 35989182,
                "href":"/products/maynicoffee",
                "tooltip": {
                    "content": "<div class='map_image_wrap'> <div class='map_back_with_video_text'> <div class='map_video'> <iframe width='560' height='315' src='https://www.youtube.com/embed/9TPb4xGZkpg' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen=''></iframe></div> <div class='map-video_with_text'><div class='map_video_text'> <div class='video_title'> <h3>Mayni</h3> </div> <div class='video_content'><p>The Mayni harness their natural landscape while protecting the natural eco-system, foliage and wildlife, expertly handpicking their beautiful crop to minimise any damage. </p></div><div class='map_btn_wrap'> <a class='btn' href='#'> Shop Mayni coffee <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'></path> </svg> </a> </div> </div> </div> </div> </div>"
                }
            }
      },
      
    });
  
  
});
$(document).ready(function(){
  $('.announcement_bar_wrapper').slick({
     dots: false,
     arrows: false,
     autoplay: true,
  autoplaySpeed: 2000
  });
});


  
